import axios  from "axios"

export default {
    async registerDrug(data) {
        return await axios.post('drug-inventory', data)
        .then(({data}) => data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async getDrugs(dataOptions, search) {
        var url = `drug-inventory?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getdrug(id) {
        // http://3.218.20.78:3002/api/admin/user?page=1&limit=10
        // var url = `admin/farm?page=${page}&limit=${limit}`
        var url = `drug-inventory/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async editdrug(data) {
        var url = `drug-inventory`
        return await axios.put(url, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
    async deleteDrug(data) {
        let newData={
            "drugNumber":data
        }
        var url = `drug-inventory`
        return await axios.delete(url,{data:newData})
        .then((result) => result.data)
        
        .catch( error => Promise.reject(error));
    },

}